import type {
  AtterbergGeneral,
  AtterbergDetail,
  AtterbergSamplePreparation,
  AtterbergLLMethod,
  AtterbergLLActuation,
  AtterbergGroovingTool,
} from '../../../types/atterberg';

export const samplePreparationOptions: { value: AtterbergSamplePreparation; label: string }[] = [
  { value: 'Natural', label: 'in natural condition' },
  { value: 'HandRemoved425', label: 'after >425µm removed by hand' },
  { value: 'WashRemoved425', label: 'after washing to remove >425µm' },
];

export const llMethodOptions: { value: AtterbergLLMethod; label: string }[] = [
  { value: 'Multipoint', label: 'Multipoint' },
  { value: 'SinglePoint', label: 'Single-point' },
];

export const llActuationOptions: { value: AtterbergLLActuation; label: string }[] = [
  { value: 'Manual', label: 'Manual' },
  { value: 'Mechanical', label: 'Mechanical' },
];

export const groovingToolOptions: { value: AtterbergGroovingTool; label: string }[] = [
  { value: 'Metal', label: 'Metal' },
  { value: 'Plastic', label: 'Plastic' },
];

export const EMPTY_GENERAL: AtterbergGeneral = {
  samplePreparation: null,
  totalMassOfSample: null,
  massRetained425um: null,
  llMethod: 'Multipoint',
  llMechanicalOrManual: null,
  llDeviceNo: null,
  llOvenNo: null,
  llOvenTemperatureC: 110,
  plPerformedByHand: true,
  plRollingDeviceNo: null,
  plGroovingToolMaterial: null,
  plOvenNo: null,
  plOvenTemperatureC: 110,
  organic: false,
  isNonPlastic: false,
  overrideLL: null,
  overridePL: null,
  overridePI: null,
  overrideUSCSGroupSymbol: null,
  comments: null,
  computedLL: null,
  computedPL: null,
  computedPI: null,
  uscsGroupSymbol: null,
  llRegressionSlope: null,
  llRegressionIntercept: null,
};

const emptyTrial = (type: 'LL' | 'PL', n: number, isRetest = false): AtterbergDetail => ({
  trialType: type,
  trialNumber: n,
  isRetest,
  _key: null,
  containerNo: null,
  massOfContainer: null,
  massOfWetSoilAndContainer: null,
  massOfDrySoilAndContainer: null,
  numberOfBlows: null,
  computedWaterContent: null,
  computedMassOfMoistSoil: null,
  computedMassOfDrySoil: null,
  computedSinglePointLL: null,
});

export const EMPTY_LL_TRIALS: AtterbergDetail[] = [1, 2, 3, 4].map((n) => emptyTrial('LL', n));
export const EMPTY_PL_TRIALS: AtterbergDetail[] = [1, 2].map((n) => emptyTrial('PL', n));
/** FEAT-2026-0001: 4 oven-dried LL retest slots, mirroring the primary LL pass. */
export const EMPTY_RETEST_LL_TRIALS: AtterbergDetail[] = [1, 2, 3, 4].map((n) => emptyTrial('LL', n, true));

export const MAX_LL_TRIALS = 4;
export const MAX_PL_TRIALS = 2;
export const MAX_RETEST_LL_TRIALS = 4;
